"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.move = void 0;
function move(array, from, to) {
    const result = array.slice();
    result.splice(to, 0, result.splice(from, 1)[0]);
    return result;
}
exports.move = move;
